var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "animated fadeIn"
  }, [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _c('b-card', [_c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', [_c('section', [_c('div', {
    staticClass: "card-header-tab",
    staticStyle: {
      "margin-left": "10px"
    }
  }, _vm._l((_vm.tabs), function(tab) {
    return _c('button', {
      key: tab.key,
      class: ['tab-button ', {
        active: _vm.currentTab === tab.key
      }],
      attrs: {
        "title": tab.value
      },
      on: {
        "click": function($event) {
          _vm.currentTab = tab.key
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t  " + _vm._s(tab.value) + "\n\t\t\t\t\t\t")])
  })), _vm._v(" "), _c('keep-alive', [_c(_vm.currentTabComponent, {
    key: _vm.componentKey,
    tag: "component",
    staticClass: "tab"
  })], 1)], 1)])])]), _vm._v(" "), (_vm.picked == 1) ? _c('b-card', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmitSearch($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('label'), _vm._v(" "), _c('b-input-group', [_c('label', [_vm._v("Shipment ID/AWB No.")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#449d42",
      "font-size": "11px"
    }
  }, [_vm._v("Note:Use Comma (,) For Multiple ID's Without Space. Maximum 10 AWBs Allowed")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('label'), _vm._v(" "), _c('b-input-group', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipmentId),
      expression: "shipmentId"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('shipmentId')
    },
    attrs: {
      "name": "shipmentId",
      "id": "shipmentId",
      "placeholder": "Enter Shipment ID/AWB No"
    },
    domProps: {
      "value": (_vm.shipmentId)
    },
    on: {
      "keydown": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.preventDefault();
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "space", 32)) { return null; }
        (function (event) { return event.preventDefault(); })($event)
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shipmentId = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('shipmentId')),
      expression: "errors.has('shipmentId')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please enter Shipment ID(s)")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.awbErr),
      expression: "awbErr"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.awbErr))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label'), _vm._v(" "), _c('b-input-group', [_c('label', [_vm._v("Comments")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#449d42",
      "font-size": "11px"
    }
  }, [_vm._v("Note:Maximum Length 500 Character")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('label'), _vm._v(" "), _c('b-input-group', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.comments),
      expression: "comments"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('comments')
    },
    attrs: {
      "pattern": "/^.{1,500}$",
      "name": "comments",
      "id": "comments",
      "placeholder": "Enter Comments"
    },
    domProps: {
      "value": (_vm.comments)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.comments = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('comments')),
      expression: "errors.has('comments')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.errors.first('comments')))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.commenterr),
      expression: "commenterr"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.commenterr))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group ",
    staticStyle: {
      "margin-left": "33rem"
    }
  }, [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('b-input-group', [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Update")]), _vm._v("   \n                        "), _c('button', {
    staticClass: "-btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.reset
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Reset")])])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.picked == 2) ? _c('b-card', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onPRQSubmitSearch($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('label'), _vm._v(" "), _c('b-input-group', [_c('label', [_vm._v("Pickup Requests No.")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#449d42",
      "font-size": "11px"
    }
  }, [_vm._v("Note:Use Comma (,) For Multiple PRQ's Without Space. Maximum 10 PRQs Allowed")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('label'), _vm._v(" "), _c('b-input-group', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.prqId),
      expression: "prqId"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('prqId')
    },
    attrs: {
      "name": "prqId",
      "id": "prqId",
      "placeholder": "Enter Pickup Request No"
    },
    domProps: {
      "value": (_vm.prqId)
    },
    on: {
      "keydown": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.preventDefault();
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "space", 32)) { return null; }
        (function (event) { return event.preventDefault(); })($event)
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.prqId = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('prqId')),
      expression: "errors.has('prqId')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please enter Pickup Request(s) No.")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.prqErr),
      expression: "prqErr"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.prqErr))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label'), _vm._v(" "), _c('b-input-group', [_c('label', [_vm._v("Comments")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#449d42",
      "font-size": "11px"
    }
  }, [_vm._v("Note:Maximum Length 500 Character")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('label'), _vm._v(" "), _c('b-input-group', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.prqcomments),
      expression: "prqcomments"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('prqcomments')
    },
    attrs: {
      "pattern": "/^.{1,500}$",
      "name": "prqcomments",
      "id": "prqcomments",
      "placeholder": "Enter Comments"
    },
    domProps: {
      "value": (_vm.prqcomments)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.prqcomments = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('prqcomments')),
      expression: "errors.has('prqcomments')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.errors.first('prqcomments')))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.prqcommenterr),
      expression: "prqcommenterr"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.prqcommenterr))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group ",
    staticStyle: {
      "margin-left": "33rem"
    }
  }, [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('b-input-group', [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onPRQSubmit
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Update PRQ")]), _vm._v("   \n\t\t\t    "), _c('button', {
    staticClass: "-btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.reset
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Reset")])])], 1)])]) : _vm._e(), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "lg"
    },
    on: {
      "ok": function($event) {
        _vm.showAWBInvalid = false
      }
    },
    model: {
      value: (_vm.showAWBInvalid),
      callback: function($$v) {
        _vm.showAWBInvalid = $$v
      },
      expression: "showAWBInvalid"
    }
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle",
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("Mark shipment invalid")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeShowAWBInvalid
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('fieldset', [_c('div', [_c('table', {
    staticClass: "styled-table",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', {
    staticClass: "th"
  }, [_c('tr', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("AWB")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Status")])])]), _vm._v(" "), _vm._l((_vm.finalresult), function(data) {
    return _c('tbody', [_c('tr', {
      staticClass: "text-primary",
      staticStyle: {
        "width": "100%"
      }
    }, [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.awb))]), _vm._v(" "), _c('td', {
      staticClass: "text-center "
    }, [_vm._v(_vm._s(data.result))])])])
  })], 2)])])])], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "lg"
    },
    on: {
      "ok": function($event) {
        _vm.showPRQInvalid = false
      }
    },
    model: {
      value: (_vm.showPRQInvalid),
      callback: function($$v) {
        _vm.showPRQInvalid = $$v
      },
      expression: "showPRQInvalid"
    }
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle",
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("Mark Pickup Request invalid")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeShowPRQInvalid
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('fieldset', [_c('div', [_c('table', {
    staticClass: "styled-table",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', {
    staticClass: "th"
  }, [_c('tr', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Pickup Request")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Status")])])]), _vm._v(" "), _vm._l((_vm.finalprqresult), function(data) {
    return _c('tbody', [_c('tr', {
      staticClass: "text-primary",
      staticStyle: {
        "width": "100%"
      }
    }, [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.pickuprequest))]), _vm._v(" "), _c('td', {
      staticClass: "text-center "
    }, [_vm._v(_vm._s(data.result))])])])
  })], 2)])])])], 1)], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a57411a","hasScoped":true}!./src/modules/utility/views/markAWBInvalid/markAWBInvalid.component.html
// module id = 2121
// module chunks = 3